import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }

  // Ban hint set by the axios 403 interceptor (services/api.ts). When the
  // user's account is suspended, the profile fetch fails before student is
  // hydrated, so isAuthenticated would be false and we'd send them to
  // /login. Route to /banned instead so they see why.
  if (!isAuthenticated && typeof window !== 'undefined') {
    try {
      if (sessionStorage.getItem('lomi_ban_detail')) {
        return <Navigate to="/banned" replace />;
      }
    } catch {
      /* sessionStorage may be unavailable */
    }
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
